<label [for]="id">
  <input
    [id]="id"  
    type="checkbox"
    (change)="change($event)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [class.validation]="validation"
    [class.pristine]="pristine"
    [class.dirty]="dirty"
    [class.touched]="touched"
    [class.invalid]="invalid"
    [class.valid]="valid" 
    [checked]="isChecked ? isChecked : value"/>
    <div class="v-input"><div [hidden]="isChecked? !isChecked : !value" class="icon-check"></div></div>
  <div class="content">
    <ng-content></ng-content>
    <p *ngIf="subtitle" class="field-subtitle">{{ subtitle }}</p>
  </div>
</label>
<div class="messages" *ngIf="showMessages">
  <ng-content select="app-form-error"></ng-content>
</div>
